export default __webpack_public_path__ + "static/media/header.7a450d72.png";